export const breakpoints = <const>{
  small: '40em',
  medium: '54em',
  large: '64em',
  huge: '80em'
}

export type Breakpoints = typeof breakpoints
